import { clusteredMarker } from '../icons/clustered-marker';
import { defaultMarker } from '../icons/default-marker';
import { recommendedMarker } from '../icons/recommended-marker';
import { saturatedMarker } from '../icons/saturated-marker';
import { startPointMarker } from '../icons/start-point-marker';

//----- START POINT MARKER --------------------------------------------------------------------------------------------------------------------------------------------
const START_POINT_FLAG_SIZE_DEFAULTS = {
    scaledSize: new google.maps.Size(27, 42),
    anchor: new google.maps.Point(13, 21)
};

export const START_POINT_FLAG = (overrides = {}): google.maps.MarkerOptions => ({
    icon: {
        url: startPointMarker,
        ...START_POINT_FLAG_SIZE_DEFAULTS,
        ...overrides
    },
    zIndex: 2
});

//----- DEFAULT MARKER --------------------------------------------------------------------------------------------------------------------------------------------
const ITEM_SIZE_DEFAULT = {
    scaledSize: new google.maps.Size(40, 40),
    anchor: new google.maps.Point(20, 20)
};

export const DEFAULT_MARKER = (index, overrides = {}): google.maps.MarkerOptions => ({
    icon: {
        url: defaultMarker(index),
        ...ITEM_SIZE_DEFAULT,
        ...overrides
    },
    zIndex: 3,
});

export const RECOMMENDED_MARKER = (index = '', overrides = {}): google.maps.MarkerOptions => ({
    icon: {
        url: recommendedMarker(index),
        ...ITEM_SIZE_DEFAULT,
        ...overrides
    },
    zIndex: 2,
});

export const CLUSTERED_MARKER = (index, overrides = {}): google.maps.MarkerOptions => ({
    icon: {
        url: clusteredMarker(index),
        ...ITEM_SIZE_DEFAULT,
        ...overrides
    },
    zIndex: 2,
});

//----- SATURATED MARKER --------------------------------------------------------------------------------------------------------------------------------------------
const ITEM_SIZE_SATURATED = {
    scaledSize: new google.maps.Size(80, 80),
    anchor: new google.maps.Point(40, 40)
};

export const SATURATED_MARKER = (index, overrides = {}): google.maps.MarkerOptions => ({
    icon: {
        url: saturatedMarker(index),
        ...ITEM_SIZE_SATURATED,
        ...overrides
    },
    zIndex: 4,
});


//----- PROYECTED POINT MARKER --------------------------------------------------------------------------------------------------------------------------------------------
const PROYECTED_CIRCLE_DEFAULTS = {
    scale: 20,
    fillColor: '#eff3f8',
    fillOpacity: 1,
    strokeWeight: 1.75,
    strokeColor: '#0072CE',
    
};

const PROYETED_ARROW_DEFAULTS = {
    scale: 6,
    fillColor: '#0072CE',
    fillOpacity: 1,
    strokeWeight: 0.75,
    strokeColor: '#FFFFFF',
    rotation: 0,
    anchor: new google.maps.Point(0, 2.5)
};

export const PROYECTED_CIRCLE = (overrides = {}): google.maps.MarkerOptions => ({
    icon: {
        path: google.maps.SymbolPath.CIRCLE,
        ...PROYECTED_CIRCLE_DEFAULTS,
        ...overrides
    },
    zIndex: 9000001
});

export const PROYETED_ARROW = (overrides = {}): google.maps.MarkerOptions => ({
    icon: {
        path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
        ...PROYETED_ARROW_DEFAULTS,
        ...overrides
    },
    zIndex: 9000002
});
